<div class="filter">
  <div
    *ngIf="filterStatuses"
    class="filter__item">
    <app-filter-select
      [filterTitle]="'statuses'"
      [filter]="filterStatuses">
    </app-filter-select>
  </div>
  <div
    *ngIf="filterBanks"
    class="filter__item">
    <app-filter-select
      [filterTitle]="'banks'"
      [filter]="filterBanks">
    </app-filter-select>
  </div>
</div>
